import React, { useEffect, useImperativeHandle, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import FieldError from '../../../../shared/fields-errors/field-error';
import { CAMPAIGNS_NAMES, SAVE_FUNDRAISING_SETTINGS } from '../../../../constants/endpoints';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { SPOTLIGHT_PRESET_COLORS } from '../../../../utils/utils';

const AssignCampaign = React.forwardRef((props,ref) => {
    //props
    const [loader, setLoader] = useState(false);
    const navigate = useNavigate();
    const [donorEmail, setDonorEmail] = useState("");
    const { register, handleSubmit, watch ,reset, setValue, formState: { errors } } = useForm({
        defaultValues: props?.isOfflineDonation ? {
            campaign_id:'',
            type: '',
        } : {
            type: '',
            campaign_id:'',
            show_pledge_qr: false,
            show_name_panel: true,
            show_confetti: true,
            display_layout: 'classic',
            theme_color: '#155C4E',
        }
    });
    const [show, setShow] = useState(false);
    const [type, setType] = useState("");
    const [campaignList, setCampaignList] = useState([]);
    const [currentValue, setCurrentValue] = useState({});
    const watchFields = watch();

    // methods
    const handleClose = () => {
        setDonorEmail("");
        setCurrentValue({});
        setType("");
        if(props?.isOfflineDonation){
            reset({
            campaign_id:''
        })
        }else{
            reset({
            campaign_id:'',
            show_pledge_qr: false,
            show_name_panel: true,
            show_confetti: true,
            display_layout: 'classic',
            theme_color: '#155C4E',
        })
        }
        
        setShow(false);
    };

    const handleShow = (value, type) => {
        if(type){
            setType(type);
        }
        if(value?.id){
            setCurrentValue(value);
        }
        
        setShow(true);
    }

    useImperativeHandle(ref, () => {
        return {
            handleShow: handleShow,
            setShow: setShow,
            setDonorEmail: setDonorEmail
        };
    });

    const assignCampaign = (formValues) => {
        const { type, ...payload } = formValues;
        setLoader(true);
        axios.post(`${SAVE_FUNDRAISING_SETTINGS}`, payload)
        .then((res) => {
            setLoader(false);
          if (res?.data?.status) {
                props?.callback();
                handleClose();
          }else{
            alert(res?.data?.message ? res?.data?.message : 'Failed to save settings');
          }
        }).catch((error) => {
            setLoader(false);
            alert('Failed to save settings');
        });
    }

    const getCampaigns = () => {
        setLoader(true);
        axios.get(`${CAMPAIGNS_NAMES}both`)
          .then((res) => {
            setLoader(false);
            if (res?.data?.status) {
                setCampaignList(res?.data?.response);
            }
          }).catch((error) => {
            setLoader(false);
          });
    };

    useEffect(() => {
        if(type || props?.isOfflineDonation){
            getCampaigns();
        }
    }, [type, props?.isOfflineDonation]);

    useEffect(() => {
        if(campaignList?.length > 0 && !props?.isOfflineDonation){
            if(currentValue?.id){
                reset({
                    campaign_id: currentValue?.campaign?.id,
                    type: currentValue?.campaign?.type,
                    id: currentValue?.id,
                    show_pledge_qr: currentValue?.show_pledge_qr,
                    show_name_panel: currentValue?.show_name_panel,
                    show_confetti: currentValue?.show_confetti,
                    display_layout: currentValue?.display_layout || 'classic',
                    theme_color: currentValue?.theme_color || '#155C4E',
                });
            }
            
        }
    }, [campaignList])
    
    return (
        <>
            <Modal
                keyboard={false}
                backdrop="static" show={show} onHide={handleClose} animation={true}>
                <Form onSubmit={handleSubmit(props?.isOfflineDonation ? ((formValues) => {
                    const campaign = campaignList.find(it => it.id === formValues?.campaign_id);
                    if(campaign?.id){
                        navigate(`/offline-donation/${formValues?.campaign_id}/${campaign.campaign_title}/${campaign.type}/${donorEmail ? `?email=${donorEmail}` : ''}`)
                    }
                    
                }) : assignCampaign)}>
                    <Modal.Header closeButton>
                        <Modal.Title className='text-capitalize'>{props?.isOfflineDonation ? 'Select Campaign' : `Assign ${type}`}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Group className="mb-3" >
                            <Form.Label className='text-capitalize'>Select type</Form.Label>
                            <Form.Select {...register("type", {
                                required: {
                                    value: true,
                                    message: "This field is required"
                                }
                            })}>
                            <option value="" >--Select--</option>
                            <option key={`1`} value='product'>{'Product'}</option>
                            <option key={`2`} value='campaign'>{'Campaign'}</option>
                                    
                            </Form.Select>
                            {errors?.type ? <FieldError message={errors?.type?.message} /> : ''}
                        </Form.Group>
                        <Form.Group className="mb-3" >
                            <Form.Label className='text-capitalize'>Select {watchFields?.type}</Form.Label>
                            <Form.Select {...register("campaign_id", {
                                required: {
                                    value: true,
                                    message: "This field is required"
                                }
                            })}>
                            <option value="">--Select--</option>
                                {watchFields?.type !== '' ?
                                    (campaignList?.map((item, index) => {
                                        if(watchFields?.type === 'product' && item?.type === 'product'){
                                        return <option key={`prod_${index}`} value={item?.id}>{item?.campaign_title}</option>}
                                        else if(watchFields?.type !== 'product' && item?.type !== 'product'){
                                        return <option key={`cam_${index}`} value={item?.id}>{item?.campaign_title}</option>}
                                    })) : ''
                                }
                            </Form.Select>
                            {errors?.campaign_id ? <FieldError message={errors?.campaign_id?.message} /> : ''}
                        </Form.Group>
                        {
                            !props?.isOfflineDonation ? 
                      <>
                        <div className='mt-2'>
                    <label className="form-control-label d-flex align-items-center" >
                        <input {...register("show_pledge_qr")} className='me-1' type="checkbox" /> <span>Show Pledge QR Code</span>
                    </label>
                </div>
                        <div className='mt-2'>
                    <label className="form-control-label d-flex align-items-center" >
                        <input {...register("show_name_panel")} className='me-1' type="checkbox" /> <span>Show Name Section</span>
                    </label>
                </div>
                <div className='mt-2'>
                    <label className="form-control-label d-flex align-items-center" >
                        <input {...register("show_confetti")} className='me-1' type="checkbox" /> <span>Show Confetti</span>
                    </label>
                </div>
                <Form.Group className="mt-3">
                    <Form.Label>Display Layout</Form.Label>
                    <Form.Select {...register("display_layout")}>
                        <option value="classic">Classic</option>
                        <option value="spotlight">Spotlight</option>
                    </Form.Select>
                </Form.Group>
                {watchFields?.display_layout === 'spotlight' && (
                    <Form.Group className="mt-3">
                        <Form.Label>Spotlight Theme Color</Form.Label>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center' }}>
                            {SPOTLIGHT_PRESET_COLORS.map((c) => (
                                <button
                                    key={c}
                                    type="button"
                                    title={c}
                                    onClick={() => setValue('theme_color', c, { shouldDirty: true })}
                                    style={{
                                        width: 24, height: 24, borderRadius: '50%', background: c, cursor: 'pointer', padding: 0,
                                        border: (watchFields?.theme_color || '').toLowerCase() === c.toLowerCase() ? '2px solid #1a1a2e' : '2px solid #fff',
                                        boxShadow: '0 0 0 1px #e8eaed',
                                    }}
                                />
                            ))}
                            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, marginLeft: 4 }}>
                                <input
                                    type="color"
                                    {...register('theme_color')}
                                    style={{ width: 30, height: 30, padding: 0, border: '1px solid #e8eaed', borderRadius: 6, cursor: 'pointer', background: 'transparent' }}
                                />
                                <input
                                    type="text"
                                    value={watchFields?.theme_color || ''}
                                    maxLength={7}
                                    onChange={(e) => {
                                        const v = e.target.value;
                                        if (/^#[0-9a-fA-F]{0,6}$/.test(v)) setValue('theme_color', v, { shouldDirty: true });
                                    }}
                                    style={{ width: 88, fontSize: 13, padding: '4px 8px', border: '1px solid #e8eaed', borderRadius: 6, textTransform: 'uppercase' }}
                                />
                            </span>
                        </div>
                    </Form.Group>
                )}
                      </> : ''
                        }
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="default" onClick={handleClose}>
                            Cancel
                        </Button>
                        <Button disabled={loader} type='submit' variant="primary"
                            className={`${loader ? 'position-relative button--loading' : ''}`}>
                            {props?.isOfflineDonation ? 'Add Offline Donation' : 'Save'}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </>
    );
});

export default AssignCampaign;